// extracted by css-extract-rspack-plugin
export default {"dropdownBody":"_9014f93c"};